<template>
  <div :class="{english:lang=='EN'}">
    <div class="hidden-xs">
      <div class="footer">
        <div class="footer-wrapper">
          <div class="logo" @click="openRouter('Home')" style="">
            <img src="../../assets/img/logo_white_en.png" style="pointer-events:auto;"/>
<!--            <img  src="../../assets/img/LOGO_with_name_EN.png" v-else style="pointer-events:auto;"/>-->
          </div>
          <div class="content">
            <div style="display: flex;justify-content: left;width: 100%;">
<!--              <div class="content-li">-->
<!--                <div class="title">{{$t('bottom.product')}}</div>-->
<!--                <div class="link" @click="openProduct('smartRobot')">{{$t('bottom.robot')}}</div>-->
<!--                <div class="link"  @click="openProduct('smartCar')">{{$t('bottom.car')}}</div>-->
<!--                <div class="link"   @click="openProduct('smartTerminal')">{{$t('bottom.terminal')}}</div>-->
<!--                <div class="link"  @click="openProduct('smartChip')">{{$t('bottom.chip')}}</div>-->
<!--              </div>-->
              <div class="content-li">
                <div class="title">{{$t('bottom.entry')}}</div>
                <div class="link"  @click="openRouter('News')">{{$t('bottom.news')}}</div>
                <div class="link"  @click="openRouter('airPort')">{{$t('bottom.solution')}}</div>
<!--                 <span @click="openRouter('airPort')">{{$t('bottom.solution')}}</span>-->
                <div class="link"  @click="openRouter('AboutUs')">{{$t('bottom.aboutUs')}}</div>
<!--                <div class="link"  @click="openRouter('ContactUs')" v-if="$store.state.lang=='CN'">{{$t('bottom.contactUs')}}</div>-->
                <!-- <span @click="openRouter('Partner')">{{$t('bottom.partner')}}</span> -->
              </div>
              <div class="content-li" >
                <div class="title" style="cursor: pointer;" @click="openRouter('ContactUs')">{{$t('bottom.contactUs')}}</div>
                <div>
                  <a href="mailto:opl@transtong.net" class="mail-to" style="text-decoration:none;">opl@transtong.net</a>
                </div>
                <div>
                  <a href="mailto:arin@transtong.net" class="mail-to" style="text-decoration:none;">arin@transtong.net</a>
                </div>
                <div>
<!--                  <a href="mailto:opl@transtong.net" class="mail-to" style="text-decoration:none;">opl@transtong.net</a>-->
                </div>
                <div v-if="lang=='CN'">0755-27747003</div>
                <div v-else>0755-27747003</div>
                <div v-if="lang=='CN'">18027669596</div>
                <div v-else>18027669596</div>
                <div v-if="lang=='CN'">13332929173</div>
                <div v-else>13332929173</div>
                <!-- <div class="wechat">
                  <img @mouseover="showPublicNo = true" @mouseleave="showPublicNo = false" src="../../assets/img/common/WeChat.png" style="width:1.44rem;height:1.13rem">
                  <img v-if="showPublicNo" class="public-no" src="../../assets/img/common/public_no.jpg">
                </div> -->
              </div>
            </div>
          </div>
        </div>
        <div class="footer-nav">
<!--            <span @click="goNewPage" style="cursor: pointer;">鲁ICP备19040548号-1 </span>© 2019-2020 Mind PointEye. All Rights Reserved. 全线通-->
          <span @click="goNewPage" style="cursor: pointer;">粤ICP备19040548号-2 </span>© 2020-2023 TRANSTONG. All Rights Reserved. 全线通
        </div>
<!--        <div class="allCountBox"><span>{{$t('bottom.allVisited')}}</span>：<span v-for="(item,index) in  $store.state.allCount.split('')" :key="index">{{item}}</span></div>-->
      </div>
    </div>
    <div class="visible-xs">
      <div class="footer">
        <div class="footer-wrapper">
          <div class="content">
            <div style="display: flex;justify-content: space-between;width: 100%;">
<!--              <div class="content-li">-->
<!--                <div class="title">{{$t('bottom.product')}}</div>-->
<!--                <div class="link"  @click="openProduct('smartRobot')">{{$t('bottom.robot')}}</div>-->
<!--                <div class="link"  @click="openProduct('smartCar')">{{$t('bottom.car')}}</div>-->
<!--                <div class="link"  @click="openProduct('smartTerminal')">{{$t('bottom.terminal')}}</div>-->
<!--                <div class="link"  @click="openProduct('smartChip')">{{$t('bottom.chip')}}</div>-->
<!--              </div>-->
              <div class="content-li">
                <div class="title">{{$t('bottom.entry')}}</div>
                <div class="link"  @click="openRouter('News')">{{$t('bottom.news')}}</div>
                <div class="link"  @click="openRouter('airPort')">{{$t('bottom.solution')}}</div>
                <!--                 <span @click="openRouter('airPort')">{{$t('bottom.solution')}}</span>-->
                <div class="link"  @click="openRouter('AboutUs')">{{$t('bottom.aboutUs')}}</div>
                <!--                <div class="link"  @click="openRouter('ContactUs')" v-if="$store.state.lang=='CN'">{{$t('bottom.contactUs')}}</div>-->
                <!-- <span @click="openRouter('Partner')">{{$t('bottom.partner')}}</span> -->
              </div>
              <div class="content-li" >
                <div class="title" style="cursor: pointer;" @click="openRouter('ContactUs')">{{$t('bottom.contactUs')}}</div>
                <div>
                  <a href="mailto:opl@transtong.net" class="mail-to" style="text-decoration:none;">opl@transtong.net</a>
                </div>
                <div>
                  <a href="mailto:arin@transtong.net" class="mail-to" style="text-decoration:none;">arin@transtong.net</a>
                </div>
                <div>
                  <!--                  <a href="mailto:opl@transtong.net" class="mail-to" style="text-decoration:none;">opl@transtong.net</a>-->
                </div>
                <div v-if="lang=='CN'">0755-27747003</div>
                <div v-else>0755-27747003</div>
                <div v-if="lang=='CN'">18027669596</div>
                <div v-else>18027669596</div>
                <div v-if="lang=='CN'">13332929173</div>
                <div v-else>13332929173</div>
                <!-- <div class="wechat">
                  <img @mouseover="showPublicNo = true" @mouseleave="showPublicNo = false" src="../../assets/img/common/WeChat.png" style="width:1.44rem;height:1.13rem">
                  <img v-if="showPublicNo" class="public-no" src="../../assets/img/common/public_no.jpg">
                </div> -->
              </div>
            </div>
          </div>
          <div class="logo" @click.stop="openRouter('Home')">
            <img  src="../../assets/img/logo_white_en.png" style="pointer-events:auto;"/>
          </div>
        </div>

        <div class="footer-nav">
          <div class="nav">
            <span><span @click="goNewPage" style="cursor: pointer;">鲁ICP备19040548号-1</span>© 2020-2022 TRANSTONG. All Rights Reserved. 全线通</span>
          </div>
        </div>
<!--        <div class="allCountBox"><span>{{$t('bottom.allVisited')}}</span>：<span v-for="(item,index) in $store.state.allCount.split('')" :key="index">{{item}}</span></div>-->
      </div>
    </div>
  </div>

</template>

<script>
  import {mapGetters} from 'vuex'

  export default {
    name: 'Footer',
    components: {},
    props: {},
    data() {
      return {
        showPublicNo: false,
        // allCount:this.$store.state.allCount
      }
    },
    methods: {
      // 备案调整
      goNewPage(){
          window.open('http://www.beian.miit.gov.cn','_blank');
      },
      openProduct(routerName) {
        if (this.$route.name == routerName) {
          window.scrollTo(0, 0)
          return
        }
        this.$router.push({
          name: routerName
        })
      },
      openRouter(routerName) {
        if (this.$route.name == routerName) {
          window.scrollTo(0, 0)
          return
        }else if(routerName==="JoinUs"){
          if(this.$store.state.isMobile){
            this.$router.push({name: routerName})
          }else{
             let routeData = this.$router.resolve({
              name: "JoinUs",
            });
            window.open(routeData.href, '_blank');
          }

        }else{
           this.$router.push({name: routerName})
        }

      },
      backHome() {
        this.$router.push('/')
      }
    },
    mounted() {
      // console.log(this.$store.state.allCount);
      // 移动端-底部查看二维码
      $(document.body).click(function(event){
        $('#img1').hide();
        $('#img2').click(function(event){
            event.stopPropagation();
            $('#img1').show();
        })
        $('#img1').click(function(event){
          event.stopPropagation();
          $('#img1').show();
        })
      })
    },
    computed: {
      ...mapGetters(['lang','isMobile','allCount']),
      getComponentName() {
        return 'Fotter'
      }
    }

  }
</script>

<style lang="scss" scoped>
  .footer {
    height: 22.79rem;
    width: 100%;
    display: flex;
    flex-direction: column;
    background: #babbbd;

    .footer-wrapper {
      width: 100%;
      display: flex;
      justify-content: space-between;
      height: 19.06rem;

      .logo {
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        width: 47.5%;

        img {
           width: 20.75rem;
           height:5.75rem;
        }
      }

      .content {
        display: flex;
        justify-content: left;
        align-items: center;
        width: 52.5%;
        // height: 19.06rem;

        font-size: 0.88rem;
        font-family: Arial, Source Han Sans CN;
        font-weight: 300;
        color: rgba(138, 152, 178, 1);
        line-height: 2.25rem;

        font-weight: 400;
        .title {
          width:10.5rem;
          font-size: 1rem;
          font-family: Arial, Source Han Sans CN;
          font-weight: 400;
          color: rgba(255, 255, 255, 1);
          line-height: 3.5rem;
          border-bottom: 0.1rem solid rgba(62, 80, 109, 1);
          margin-bottom: 1.8rem;
        }

        .wechat {
          margin-top: 0.375rem;

          .public-no {
            position: absolute;
            width: 6rem;
            height: 6rem;
            margin-top: -1.5rem;
            margin-left: 0.375rem;
          }
        }

        .content-li {
          display: flex;
          flex-direction: column;
          margin-right: 10%;
          color:#FFFFFF;
          .link:hover {
            color: #2b9eff;
            cursor: pointer;
          }

          .mail-to {
             color:#FFFFFF;
          }

          .mail-to:active, .mail-to:hover {
            color: #2b9eff;
            text-underline: none;
          }
        }
      }
    }

    .footer-nav {

      height: 3.73rem;
      font-size: 0.88rem;
      font-family: Arial, Source Han Sans CN;
      font-weight: 400;
      color: rgba(0, 0, 0, 1);
      text-align: center;
      background: #999999;
      // line-height: 3.73rem;
      padding: 1.44rem 0;
      a{
            color: rgba(138, 152, 178, 1);
      }


    }
  }
   .allCountBox{
      // background: #babbbd;
      font-size: 0.88rem;
      font-family: Arial, Source Han Sans CN;
      font-weight: 400;
      color: rgba(138, 152, 178, 1);
      text-align: center;
      background: #babbbd;
      padding-bottom:1.44rem;
        span{
          background:#2a3544;
          padding:2px 4px;
          border-radius:2px;
          margin-left: 1px;
        }
    }

  .visible-xs {

    .footer {
      width: 100%;
      height: auto;
      overflow-x: hidden;

      .footer-wrapper {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        // height: 21.5rem;

        .logo {
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          margin: 0 0 1rem 0;

          img {
            width:12.35rem;
            height: 3.8rem;
          }
        }

        .content {
          display: flex;
          justify-content: left;
          align-items: center;
          width: 85%;
          font-size: 0.8rem;
          font-family: Arial, Source Han Sans CN;
          font-weight:400;
          color: rgba(138, 152, 178, 1);
          line-height: 2.5rem;
          padding-top: 2rem;
          padding-left: 3rem;
          padding-right: 3rem;

          .title {
            width: 5rem;
            font-size: 1rem;
            font-family: Arial, Source Han Sans CN;
            font-weight: 400;
            color: rgba(255, 255, 255, 1);
            line-height: 2.5rem;
            border-bottom: 0.1rem solid rgba(62, 80, 109, 1);
            margin-bottom: 1rem;
            //margin-left: 1rem;
            //margin-right: 1rem;
          }

          .wechat {
            margin-top: 0.375rem;

            .public-no {
              position: absolute;
              width: 5rem;
              height: 5rem;
              margin-top: -3.8rem;
              margin-left: -3.5rem;
              display: none;
            }
          }

          .content-li {
            display: flex;
            flex-direction: column;
            margin-right: 0;
            white-space: nowrap;
             color:#FFFFFF;
            .link:hover {
              color: #2b9eff;
              cursor: pointer;
            }

            .mail-to {
               color:#FFFFFF;
            }

            .mail-to:active, .mail-to:hover {
              color: #2b9eff;
              text-underline: none;
            }
          }
        }
      }

      .footer-nav {
        display: flex;
        justify-content: space-evenly;
        align-items: center;
        background: #999999;
        height: auto;
        width: 100%;
        padding: 0;
        .nav {
          width: 95%;
          text-align: center;
          padding: 0.7rem 0.2rem;
          font-size: 0.6rem;
          font-family: Arial, Source Han Sans CN;
          font-weight: 400;
          color: rgba(138, 152, 178, 1);
          // line-height: 1rem;
        }
        span {
          display: inline-block;
        }
      }
      .allCountBox{
      // background: #babbbd;
      font-size: 0.6rem;
      font-family: Arial, Source Han Sans CN;
      font-weight: 400;
      color: rgba(138, 152, 178, 1);
      text-align: center;
      background: #babbbd;
      padding-bottom:0.72rem;
        span{
          background:#2a3544;
          padding:2px 4px;
          border-radius:2px;
          margin-left: 1px;
        }
    }
    }
  }

  .english {
    .hidden-xs{
      .footer .footer-wrapper .content .title{
        width:10rem;
      }

    }
    .visible-xs {
      .title {
        font-size: 0.9rem !important;
      }

      .content {
        width: 90% !important;

        .content-li {
          font-size: 0.8rem !important;
        }
      }

    }
  }

  .wechat img{
     pointer-events:auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/Footer.vue